var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseAction',[_c('SecondaryButton',{attrs:{"loading":_vm.downloading,"textColor":"#0965dc"},nativeOn:{"click":function($event){return _vm.downloadFile($event)}}},[_c('v-icon',[_vm._v(" mdi-content-copy ")]),_vm._v(" Download ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }